import React, { useState } from 'react';
import myBackground  from '../assets/sprout.png'
function DownloadLinkGenerator() {
  const [filename, setFilename] = useState('');
  const [secretKey, setSecretKey] = useState('');
  const [workerUrl, setWorkerUrl] = useState('');
  const [downloadLink, setDownloadLink] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  function bufferToHex(buffer) {
    const byteArray = new Uint8Array(buffer);
    return Array.from(byteArray)
      .map(byte => byte.toString(16).padStart(2, '0'))
      .join('');
  }

  async function computeSignature(file, expires, secret) {
    const data = `${file}:${expires}`;
    const encoder = new TextEncoder();
    const keyData = encoder.encode(secret);

    const cryptoKey = await window.crypto.subtle.importKey(
      'raw',
      keyData,
      { name: 'HMAC', hash: 'SHA-256' },
      false,
      ['sign']
    );

    const signatureBuffer = await window.crypto.subtle.sign(
      'HMAC',
      cryptoKey,
      encoder.encode(data)
    );
    return bufferToHex(signatureBuffer);
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setError(null);
    setDownloadLink('');

    if (!filename.trim()) {
      setError('Filename is required');
      return;
    }
    if (!/^[0-9a-fA-F]{64}$/.test(secretKey.trim())) {
      setError('Secret key must be exactly 64 hex digits');
      return;
    }
    if (!workerUrl.trim()) {
      setError('Worker URL is required');
      return;
    }

    setLoading(true);
    try {
      const currentTime = Math.floor(Date.now() / 1000);
      const expires = currentTime + 300;
      const signature = await computeSignature(filename.trim(), expires, secretKey.trim());

      const link = `${workerUrl.trim()}/${encodeURIComponent(filename.trim())}?expires=${expires}&signature=${signature}`;
      setDownloadLink(link);
    } catch (err) {
      setError('Error generating link: ' + err.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="w-screen h-screen bg-cover bg-center" style={{ backgroundImage: `url(${myBackground})` }}>
    <div className="flex flex-col items-center justify-center min-h-screen  text-white p-6">
      <div className="w-full max-w-lg bg-gray-800 shadow-xl rounded-2xl p-6">
        <h2 className="text-2xl font-bold text-green-400 mb-6 text-center">Download Link Generator</h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-300 mb-1">Worker URL</label>
            <input
              type="text"
              value={workerUrl}
              onChange={(e) => setWorkerUrl(e.target.value)}
              placeholder="Enter worker URL (e.g., https://your-worker-domain.workers.dev)"
              className="w-full p-2 bg-gray-700 border border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-400 text-white"
              required
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-300 mb-1">Filename</label>
            <input
              type="text"
              value={filename}
              onChange={(e) => setFilename(e.target.value)}
              placeholder="Enter filename (e.g., file.txt)"
              className="w-full p-2 bg-gray-700 border border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-400 text-white"
              required
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-300 mb-1">64-Digit Secret Key</label>
            <input
              type="text"
              value={secretKey}
              onChange={(e) => setSecretKey(e.target.value)}
              placeholder="Enter 64 hex digits"
              className="w-full p-2 bg-gray-700 border border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-400 text-white"
              required
            />
          </div>
          <button
            type="submit"
            className="w-full py-3 bg-gradient-to-r from-green-400 to-green-600 text-white font-semibold rounded-lg hover:from-indigo-500 hover:to-indigo-900 transition duration-300"
            disabled={loading}
          >
            {loading ? 'Generating...' : 'Generate Download Link'}
          </button>
        </form>
        {error && <p className="text-red-400 text-sm mt-4">{error}</p>}
        {downloadLink && (
          <div className="mt-6">
            <p className="bg-gradient-to-r from-green-400 to-green-950 font-medium">Download Link:</p>
            <a
              href={downloadLink}
              target="_blank"
              rel="noopener noreferrer"
              className="text-green-300 underline break-all"
            >
              {downloadLink}
            </a>
          </div>
        )}
      </div>
    </div>
    </div>
  );
}

export default DownloadLinkGenerator;
